import {
  CHECK_FEEDBACK_GIVEN,
  GET_ATTENDESS,
  GET_EVENT,
  GET_EVENT_IMAGES,
  SUBMIT_EVENT_FEEDBACK,
} from "../../services/endpoints";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";

import axiosAPI from "../../services/axios";
import cuid from "cuid";

export interface SubmitFeedbackRequest {
  participantEmail: string;
  eventFeedbackResponse: {
    rating: number;
    additionalComments: string;
  }
}

export const getLiveEvent = createAsyncThunk(
  "live-event",
  async (eventId: string, { rejectWithValue }) => {
    if (!cuid.isCuid(eventId)) {
      return rejectWithValue("Invalid eventId");
    }
    try {
      const { data } = await axiosAPI.request({
        url: GET_EVENT(eventId),
        method: "GET",
      });
      return data;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const refreshLiveEvent = createAsyncThunk(
  "live-event/refresh",
  async (eventId: string, { rejectWithValue }) => {
    if (!cuid.isCuid(eventId)) {
      return rejectWithValue("Invalid eventId");
    }
    try {
      const { data } = await axiosAPI.request({
        url: GET_EVENT(eventId),
        method: "GET",
      });
      return data;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getLiveEventAttendees = createAsyncThunk(
  "live-event/attendees",
  async (eventId: string, { rejectWithValue }) => {
    if (!cuid.isCuid(eventId)) {
      return rejectWithValue("Invalid eventId");
    }
    try {
      const { data } = await axiosAPI.request({
        url: GET_ATTENDESS(eventId),
        method: "GET",
      });
      return data;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const refreshLiveEventAttendees = createAsyncThunk(
  "live-event/attendees/refresh",
  async (eventId: string, { rejectWithValue }) => {
    if (!cuid.isCuid(eventId)) {
      return rejectWithValue("Invalid eventId");
    }
    try {
      const { data } = await axiosAPI.request({
        url: GET_ATTENDESS(eventId),
        method: "GET",
      });
      return data;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getLiveEventPhotos = createAsyncThunk(
  "live-event/photos",
  async (eventId: string, { rejectWithValue }) => {
    try {
      const { data } = await axiosAPI.request({
        url: GET_EVENT_IMAGES(eventId),
        method: "GET",
      });
      return data;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const refreshLiveEventPhotos = createAsyncThunk(
  "live-event/photos/refresh",
  async (eventId: string, { rejectWithValue }) => {
    try {
      const { data } = await axiosAPI.request({
        url: GET_EVENT_IMAGES(eventId),
        method: "GET",
      });
      return data;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const submitFeedback = createAsyncThunk(
  "live-event/feedback/submit",
  async (params: {eventId: string, payload: SubmitFeedbackRequest}, { rejectWithValue }) => {
    try {
      const { data } = await axiosAPI.request({
        url: SUBMIT_EVENT_FEEDBACK(params.eventId),
        method: "POST",
        data: params.payload
      });
      return data;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const submitNoFeedback = createAsyncThunk(
  "live-event/no/feedback/submit",
  async (params: {eventId: string, payload: SubmitFeedbackRequest}, { rejectWithValue }) => {
    try {
      const { data } = await axiosAPI.request({
        url: SUBMIT_EVENT_FEEDBACK(params.eventId),
        method: "POST",
        data: params.payload
      });
      return data;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const checkIfFeedbackGiven = createAsyncThunk(
  "live-event/check/feedback",
  async (params: {eventId: string, userId:string}, { rejectWithValue }) => {
    try {
      const { data } = await axiosAPI.request({
        url: CHECK_FEEDBACK_GIVEN(params.eventId, params.userId),
        method: "GET",
      });
      return data;
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const clearLiveEvent = createAction("live-event/clear");
